import contentHeader from './content-header.vue'
import connectService from './connect-service.vue'

export default {
    contentHeader,
    connectService
}